/*
 * @Author: lzz
 * @Date: 2024-06-09 12:39:57
 * @LastEditTime: 2024-08-01 10:49:37
 */
import axios from 'axios'
import {
  Notification,
  MessageBox,
  Message
} from 'element-ui'
import {
  getToken
} from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import * as api from "@/api/index.js";
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，由public/index.html中的API_PATH配置项决定
  //   baseURL: API_PATH,
  // 超时
  timeout: 10000
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  //console.log("axios-config", config);
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = res.data.msg || errorCode[code] || errorCode['default']
  if (code === 401) {
    let type = 99;
    let redirect = "/index";
    const redirectUri =
      location.origin +
      "/#/social-login?" +
      encodeURIComponent(`type=${type}&redirect=${redirect || "/"}`); // 进行跳转
    api
      .socialAuthRedirect({
        type: type,
        redirectUri: redirectUri,
      })
      .then((res) => {
        window.location.href = res.data;
      });
      return Promise.reject('登录已过期')

  } else if (code === 500) {
    //   Message({
    //     message: msg,
    //     type: 'error'
    //   })
    return Promise.reject(new Error(msg))
  } else if (code !== 200) {
    return Promise.reject(res.data)
  } else {
    return res.data
  }
},
  error => {
    console.log('err' + error)
    let {
      message
    } = error;
    if (message == "Network Error") {
      // message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      // message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      // message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    // Message({
    //   message: message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)
export default service
